<template>
  <Form
    :is-show-form-val="isShowForm"
    :is-load-form-val="isLoadForm"
    :r-kolok="rKolok"
    :r-kib="rKib"
    :title="title"
    :r-kobar="rKobar"
    :r-nabar="rNabar"
    :r-kode-register-barang="rKodeRegisterBarang"
    :r-nilai-perolehan="rNilaiPerolehan"
    :r-tahun-perolehan="rTahunPerolehan"
    :r-keberadaan="rKeberadaan"
    :r-tanda2batas-tanah-utara="rTanda2BatasTanahUtara"
    :r-tanda2batas-tanah-timur="rTanda2BatasTanahTimur"
    :r-tanda2batas-tanah-selatan="rTanda2BatasTanahSelatan"
    :r-tanda2batas-tanah-barat="rTanda2BatasTanahBarat"
    :r-alasan-tidak-ada="rAlasanTidakAda"
    :r-alasan-tidak-ada-p="rAlasanTidakAdaP"
    :r-sebab-lain="rSebabLain"
    :r-keterangan-beton="rKeteranganBeton"
    :r-keterangan-beton-sebutkan="rKeteranganBetonSebutkan"
    :r-peruntukkan-penggunaan-bmd="rPeruntukkanPenggunaanBmd"
    :r-ukuran="rUkuran"
    :r-satuan="rSatuan"
    :r-kesesuaian-ukuran="rKesesuaianUkuran"
    :r-satuan-seharusnya="rSatuanSeharusnya"
    :r-ukuran-seharusnya="rUkuranSeharusnya"
    :r-nama-spesifikasi-barang="rNamaSpesifikasiBarang"
    :r-alamat="rAlamat"
    :r-provinsi="rProvinsi"
    :r-kab-kota="rKabKota"
    :r-kecamatan="rKecamatan"
    :r-kelurahan="rKelurahan"
    :r-kode-pos="rKodePos"
    :r-jalan="rJalan"
    :r-no-alamat="rNoAlamat"
    :r-rt="rRt"
    :r-rw="rRw"
    :r-gedung-bangunan-tanah-milik="rGedungBangunanTanahMilik"
    :r-is-gedung-bangunan-tanah-milik-tercatat="rIsGedungBangunanTanahMilikTercatat"
    :r-gedung-bangunan-tanah-milik-pd-ukpd="rGedungBangunanTanahMilikPdUkpd"
    :r-gedung-bangunan-tanah-milik-kobar="rGedungBangunanTanahMilikKobar"
    :r-gedung-bangunan-tanah-milik-register="rGedungBangunanTanahMilikRegister"
    :r-gedung-bangunan-tanah-milik-keterangan="rGedungBangunanTanahMilikKeterangan"
    :r-gedung-bangunan-tanah-milik-sebutkan="rGedungBangunanTanahMilikSebutkan"
    :r-is-indikasi-ganda="rIsIndikasiGanda"
    :r-indikasi-ganda-dengan="rIndikasiGandaDengan"
    :r-indikasi-ganda-sebutkan="rIndikasiGandaSebutkan"
    :r-indikasi-gabungan="rIndikasiGabungan"
    :r-indikasi-gabungan-keterangan="rIndikasiGabunganKeterangan"
    :r-sk-penggunaan="rSkPenggunaan"
    :r-nomor-sk-penggunaan="rNomorSkPenggunaan"
    :r-tahun-sk-penggunaan="rTahunSkPenggunaan"
    :r-penggunaan="rPenggunaan"
    :r-digunakan-bersama="rDigunakanBersama"
    :r-pd-ukpd="rPdUkpd"
    :r-digunakan-untuk="rDigunakanUntuk"
    :digunakan-untuk-val="digunakanUntuk"
    :r-pemanfaat="rPemanfaat"
    :r-is-lantai-digunakan="rIsLantaiDigunakan"
    :r-jumlah-seluruh-lantai="rJumlahSeluruhLantai"
    :r-jumlah-lantai-digunakan="rJumlahLantaiDigunakan"
    :r-is-atap-beton="rIsAtapBeton"
    :r-is-atap-beton-is-digunakan="rIsAtapBetonIsDigunakan"
    :r-is-basement="rIsBasement"
    :r-is-basement-is-digunakan="rIsBasementIsDigunakan"
    :r-is-halaman-utama="rIsHalamanUtama"
    :r-is-halaman-utama-is-digunakan="rIsHalamanUtamaIsDigunakan"
    :r-jumlah-lantai-tidak-digunakan="rJumlahLantaiTidakDigunakan"
    :r-atap-beton-digunakan="rAtapBetonDigunakan"
    :r-basement-digunakan="rBasementDigunakan"
    :r-halaman-utama-digunakan="rHalamanUtamaDigunakan"
    :r-is-bertingkat="rIsBertingkat"
    :r-pengamanan-fisik="rPengamananFisik"
    :r-fisik-dikuasai="rFisikDikuasai"
    :r-fisik-dikuasai-sebutkan="rFisikDikuasaiSebutkan"
    :r-fisik-tidak-dikuasai-sebutkan="rFisikTidakDikuasaiSebutkan"
    @emitInputRegister="inputRegister"
  />
</template>
<script>
import { ref } from '@vue/composition-api'
import Form from '@/views/koreksi/cleansing/Form.vue'
import UtilsFunction from '@/views/koreksi/UtilsFunction'

export default {
  setup(props, context) {
    const g = context.root

    const utilsFunction = new UtilsFunction(g)

    const defaultVNull = { text: '-- Pilih Salah Satu --', value: null }
    const title = ref('KIB C - Fase Desktop')

    // form name
    const isLoadForm = ref(false)
    const isShowForm = ref(false)

    const digunakanUntuk = ref([])

    // form real
    const rKolok = ref('')
    const rKib = ref('')
    const rKobar = ref('')
    const rNabar = ref('')
    const rKodeRegisterBarang = ref('')
    const rNilaiPerolehan = ref('')
    const rTahunPerolehan = ref('')
    const rTanda2BatasTanahUtara = ref('')
    const rTanda2BatasTanahTimur = ref('')
    const rTanda2BatasTanahSelatan = ref('')
    const rTanda2BatasTanahBarat = ref('')
    const rKeberadaan = ref('')
    const rAlasanTidakAda = ref('')
    const rAlasanTidakAdaP = ref('')
    const rSebabLain = ref('')
    const rKeteranganBeton = ref('')
    const rKeteranganBetonSebutkan = ref('')
    const rPeruntukkanPenggunaanBmd = ref('')
    const rUkuran = ref('')
    const rSatuan = ref('')
    const rKesesuaianUkuran = ref('')
    const rSatuanSeharusnya = ref('')
    const rUkuranSeharusnya = ref('')
    const rNamaSpesifikasiBarang = ref('')
    const rAlamat = ref('')
    const rProvinsi = ref('')
    const rKabKota = ref('')
    const rKecamatan = ref('')
    const rKelurahan = ref('')
    const rKodePos = ref('')
    const rJalan = ref('')
    const rNoAlamat = ref('')
    const rRt = ref('')
    const rRw = ref('')
    const rGedungBangunanTanahMilik = ref('')
    const rIsGedungBangunanTanahMilikTercatat = ref('')
    const rGedungBangunanTanahMilikPdUkpd = ref(defaultVNull)
    const rGedungBangunanTanahMilikKobar = ref(defaultVNull)
    const rGedungBangunanTanahMilikRegister = ref(defaultVNull)
    const rGedungBangunanTanahMilikKeterangan = ref('')
    const rGedungBangunanTanahMilikSebutkan = ref('')
    const rIsIndikasiGanda = ref('')
    const rIndikasiGandaDengan = ref('')
    const rIndikasiGandaSebutkan = ref('')
    const rIndikasiGabungan = ref('')
    const rIndikasiGabunganKeterangan = ref('')
    const rSkPenggunaan = ref('')
    const rNomorSkPenggunaan = ref('')
    const rTahunSkPenggunaan = ref('')
    const rPenggunaan = ref('')
    const rDigunakanUntuk = ref([])
    const rPemanfaat = ref([
      {
        value: null,
        namaPemanfaat: '',
        dasarPenggunaan: '',
        dasarPenggunaanTipe: '',
      },
    ])
    const rPdUkpd = ref([])
    const rDigunakanBersama = ref([])
    const rIsLantaiDigunakan = ref('')
    const rJumlahLantaiDigunakan = ref('')
    const rJumlahSeluruhLantai = ref('')
    const rIsAtapBeton = ref('')
    const rIsAtapBetonIsDigunakan = ref('')
    const rIsBasement = ref('')
    const rIsBasementIsDigunakan = ref('')
    const rIsHalamanUtama = ref('')
    const rIsHalamanUtamaIsDigunakan = ref('')
    const rJumlahLantaiTidakDigunakan = ref('')
    const rAtapBetonDigunakan = ref('')
    const rBasementDigunakan = ref('')
    const rHalamanUtamaDigunakan = ref('')
    const rIsBertingkat = ref('')
    const rPengamananFisik = ref('')
    const rFisikDikuasai = ref('')
    const rFisikDikuasaiSebutkan = ref('')
    const rFisikTidakDikuasaiSebutkan = ref('')

    ///
    const dataKib = ref([])
    const dataPdUkpd = ref([])
    const dataGedungBangunanTanahMilikRegister = ref([defaultVNull])
    const dataGedungBangunanTanahMilikKobar = ref([defaultVNull])
    const dataProvinsi = ref([defaultVNull])
    const dataKabKota = ref([defaultVNull])
    const dataKecamatan = ref([defaultVNull])
    const dataKelurahan = ref([defaultVNull])
    const dataKobar = ref([])

    const isShowInfo = ref(false)

    const getData = async id => {
      isShowForm.value = true
      isLoadForm.value = true
      const result = await utilsFunction.getBmdById(id)
      rKolok.value = result.kolok
      rKib.value = result.kib
      rKobar.value = result.kobar
      rNabar.value = result.nabar
      rKodeRegisterBarang.value = result.kodeRegisterBarang
      rNilaiPerolehan.value = result.nilaiPerolehan
      rTahunPerolehan.value = result.tahunPerolehan
      rKeberadaan.value = result.keberadaan
      rTanda2BatasTanahUtara.value = result.tanda2BatasTanahUtara
      rTanda2BatasTanahTimur.value = result.tanda2BatasTanahTimur
      rTanda2BatasTanahSelatan.value = result.tanda2BatasTanahSelatan
      rTanda2BatasTanahBarat.value = result.tanda2BatasTanahBarat
      rAlasanTidakAda.value = result.alasanTidakAda
      rAlasanTidakAdaP.value = result.alasanTidakAdaP
      rSebabLain.value = result.sebabLain
      rKeteranganBeton.value = result.keteranganBeton
      rKeteranganBetonSebutkan.value = result.keteranganBetonSebutkan
      rPeruntukkanPenggunaanBmd.value = result.peruntukkanPenggunaanBmd
      rUkuran.value = result.ukuran
      rSatuan.value = result.satuan
      rKesesuaianUkuran.value = result.kesesuaianUkuran
      rSatuanSeharusnya.value = result.satuanSeharusnya
      rUkuranSeharusnya.value = result.ukuranSeharusnya
      rNamaSpesifikasiBarang.value = result.namaSpesifikasiBarang
      rAlamat.value = result.alamat
      rProvinsi.value = result.provinsi
      rKabKota.value = result.kabKota
      rKecamatan.value = result.kecamatan
      rKelurahan.value = result.kelurahan
      rKodePos.value = result.kodePos
      rJalan.value = result.jalan
      rNoAlamat.value = result.noAlamat
      rRt.value = result.rt
      rRw.value = result.rw
      rGedungBangunanTanahMilik.value = result.gedungBangunanTanahMilik
      rIsGedungBangunanTanahMilikTercatat.value = result.isGedungBangunanTanahMilikTercatat
      rGedungBangunanTanahMilikPdUkpd.value = result.gedungBangunanTanahMilikPdUkpd
      rGedungBangunanTanahMilikKobar.value = result.gedungBangunanTanahMilikKobar
      rGedungBangunanTanahMilikRegister.value = result.gedungBangunanTanahMilikRegister
      rGedungBangunanTanahMilikKeterangan.value = result.gedungBangunanTanahMilikKeterangan
      rGedungBangunanTanahMilikSebutkan.value = result.gedungBangunanTanahMilikSebutkan
      rIsIndikasiGanda.value = result.isIndikasiGanda
      rIndikasiGandaDengan.value = result.indikasiGandaDengan
      rIndikasiGandaSebutkan.value = result.indikasiGandaSebutkan
      rIndikasiGabungan.value = result.indikasiGabungan
      rIndikasiGabunganKeterangan.value = result.indikasiGabunganKeterangan
      rSkPenggunaan.value = result.skPenggunaan
      rNomorSkPenggunaan.value = result.nomorSkPenggunaan
      rTahunSkPenggunaan.value = result.tahunSkPenggunaan
      rPenggunaan.value = result.penggunaan
      rDigunakanBersama.value = result.digunakanBersama
      rPdUkpd.value = result.pdUkpd
      rDigunakanUntuk.value = result.digunakanUntuk
      digunakanUntuk.value = result.digunakanUntuk.map(() => ({
        value: null,
      }))
      rPemanfaat.value = result.pemanfaat
      rIsLantaiDigunakan.value = result.isLantaiDigunakan
      rJumlahSeluruhLantai.value = result.jumlahSeluruhLantai
      rJumlahLantaiDigunakan.value = result.jumlahLantaiDigunakan
      rIsAtapBeton.value = result.isAtapBeton
      rIsAtapBetonIsDigunakan.value = result.isAtapBetonIsDigunakan
      rIsBasement.value = result.isBasement
      rIsBasementIsDigunakan.value = result.isBasementIsDigunakan
      rIsHalamanUtama.value = result.isHalamanUtama
      rIsHalamanUtamaIsDigunakan.value = result.isHalamanUtamaIsDigunakan
      rJumlahLantaiTidakDigunakan.value = result.jumlahLantaiTidakDigunakan
      rAtapBetonDigunakan.value = result.atapBetonDigunakan
      rBasementDigunakan.value = result.basementDigunakan
      rHalamanUtamaDigunakan.value = result.halamanUtamaDigunakan
      rIsBertingkat.value = result.isBertingkat
      rPengamananFisik.value = result.pengamananFisik
      rFisikDikuasai.value = result.fisikDikuasai
      rFisikDikuasaiSebutkan.value = result.fisikDikuasaiSebutkan
      rFisikTidakDikuasaiSebutkan.value = result.fisikTidakDikuasaiSebutkan
      isLoadForm.value = false
    }
    const inputRegister = register => {
      getData(register.value)
    }
    return {
      title,
      isShowInfo,
      digunakanUntuk,
      // form submit
      isLoadForm,
      isShowForm,
      rKolok,
      rKib,
      rKobar,
      rNabar,
      rKodeRegisterBarang,
      rNilaiPerolehan,
      rTahunPerolehan,
      rTanda2BatasTanahUtara,
      rTanda2BatasTanahTimur,
      rTanda2BatasTanahSelatan,
      rTanda2BatasTanahBarat,
      rKeberadaan,
      rAlasanTidakAda,
      rAlasanTidakAdaP,
      rSebabLain,
      rKeteranganBeton,
      rKeteranganBetonSebutkan,
      rPeruntukkanPenggunaanBmd,
      rUkuran,
      rSatuan,
      rKesesuaianUkuran,
      rSatuanSeharusnya,
      rUkuranSeharusnya,
      rNamaSpesifikasiBarang,
      rAlamat,
      rProvinsi,
      rKabKota,
      rKecamatan,
      rKelurahan,
      rKodePos,
      rJalan,
      rNoAlamat,
      rRt,
      rRw,
      rGedungBangunanTanahMilik,
      rIsGedungBangunanTanahMilikTercatat,
      rGedungBangunanTanahMilikPdUkpd,
      rGedungBangunanTanahMilikKobar,
      rGedungBangunanTanahMilikRegister,
      rGedungBangunanTanahMilikKeterangan,
      rGedungBangunanTanahMilikSebutkan,
      rIsIndikasiGanda,
      rIndikasiGandaDengan,
      rIndikasiGandaSebutkan,
      rIndikasiGabungan,
      rIndikasiGabunganKeterangan,
      rSkPenggunaan,
      rNomorSkPenggunaan,
      rTahunSkPenggunaan,
      rPenggunaan,
      rDigunakanUntuk,
      rPemanfaat,
      rPdUkpd,
      rDigunakanBersama,
      rIsLantaiDigunakan,
      rJumlahSeluruhLantai,
      rJumlahLantaiDigunakan,
      rIsAtapBeton,
      rIsAtapBetonIsDigunakan,
      rIsBasement,
      rIsBasementIsDigunakan,
      rIsHalamanUtama,
      rIsHalamanUtamaIsDigunakan,
      rJumlahLantaiTidakDigunakan,
      rAtapBetonDigunakan,
      rBasementDigunakan,
      rHalamanUtamaDigunakan,
      rIsBertingkat,
      rPengamananFisik,
      rFisikDikuasai,
      rFisikDikuasaiSebutkan,
      rFisikTidakDikuasaiSebutkan,
      dataKib,
      dataPdUkpd,
      dataGedungBangunanTanahMilikRegister,
      dataProvinsi,
      dataKabKota,
      dataKecamatan,
      dataKelurahan,
      dataGedungBangunanTanahMilikKobar,
      dataKobar,
      inputRegister,
    }
  },
  components: {
    Form,
  },
}
</script>
